/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  AcceptReferenceMeasurementDto,
  BeamShapingGroupDto,
  CopyTaskItemAreaDto,
  CreateOrUpdateTaskItemDto,
  DataTypeInfoDto,
  EnumerationEvaluationParameterDto,
  EvaluationParameterScopeDto,
  GetBeamShapingGroupDto,
  GetCombinationTableDto,
  GetMedicalSystemSetupTemplate,
  GetMedicalSystemsForTaskRequestDto,
  GetNumericEvaluationParameterTemplateDto,
  GetQaEquipmentSetupTemplateDto,
  GetQaRtSystemTemplateDto,
  GetTaskItemEvaluationScopeDto,
  MedicalSystemRtSystemDto,
  MedicalSystemSetupBaseDto,
  NumericEvaluationParameterTemplateDto,
  ODataPostProcessedResultsOfTaskItemDto,
  ParameterCombinationTableDto,
  QaRtSystemTemplateDto,
  TaskItemAreaDto,
  TaskItemDto,
  TaskItemQaEquipmentSetupDto,
  TaskItemReferenceMeasurementResultsDto,
  TypesScopeDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    AcceptReferenceMeasurementDtoFromJSON,
    AcceptReferenceMeasurementDtoToJSON,
    BeamShapingGroupDtoFromJSON,
    BeamShapingGroupDtoToJSON,
    CopyTaskItemAreaDtoFromJSON,
    CopyTaskItemAreaDtoToJSON,
    CreateOrUpdateTaskItemDtoFromJSON,
    CreateOrUpdateTaskItemDtoToJSON,
    DataTypeInfoDtoFromJSON,
    DataTypeInfoDtoToJSON,
    EnumerationEvaluationParameterDtoFromJSON,
    EnumerationEvaluationParameterDtoToJSON,
    EvaluationParameterScopeDtoFromJSON,
    EvaluationParameterScopeDtoToJSON,
    GetBeamShapingGroupDtoFromJSON,
    GetBeamShapingGroupDtoToJSON,
    GetCombinationTableDtoFromJSON,
    GetCombinationTableDtoToJSON,
    GetMedicalSystemSetupTemplateFromJSON,
    GetMedicalSystemSetupTemplateToJSON,
    GetMedicalSystemsForTaskRequestDtoFromJSON,
    GetMedicalSystemsForTaskRequestDtoToJSON,
    GetNumericEvaluationParameterTemplateDtoFromJSON,
    GetNumericEvaluationParameterTemplateDtoToJSON,
    GetQaEquipmentSetupTemplateDtoFromJSON,
    GetQaEquipmentSetupTemplateDtoToJSON,
    GetQaRtSystemTemplateDtoFromJSON,
    GetQaRtSystemTemplateDtoToJSON,
    GetTaskItemEvaluationScopeDtoFromJSON,
    GetTaskItemEvaluationScopeDtoToJSON,
    MedicalSystemRtSystemDtoFromJSON,
    MedicalSystemRtSystemDtoToJSON,
    MedicalSystemSetupBaseDtoFromJSON,
    MedicalSystemSetupBaseDtoToJSON,
    NumericEvaluationParameterTemplateDtoFromJSON,
    NumericEvaluationParameterTemplateDtoToJSON,
    ODataPostProcessedResultsOfTaskItemDtoFromJSON,
    ODataPostProcessedResultsOfTaskItemDtoToJSON,
    ParameterCombinationTableDtoFromJSON,
    ParameterCombinationTableDtoToJSON,
    QaRtSystemTemplateDtoFromJSON,
    QaRtSystemTemplateDtoToJSON,
    TaskItemAreaDtoFromJSON,
    TaskItemAreaDtoToJSON,
    TaskItemDtoFromJSON,
    TaskItemDtoToJSON,
    TaskItemQaEquipmentSetupDtoFromJSON,
    TaskItemQaEquipmentSetupDtoToJSON,
    TaskItemReferenceMeasurementResultsDtoFromJSON,
    TaskItemReferenceMeasurementResultsDtoToJSON,
    TypesScopeDtoFromJSON,
    TypesScopeDtoToJSON,
} from '../models/index';

export interface CopyTaskItemAreaRequest {
    copyTaskItemAreaDto?: CopyTaskItemAreaDto;
}

export interface CreateTaskItemRequest {
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

export interface DeleteTaskItemRequest {
    id: string;
}

export interface GetCachedSetupCombinationsRequest {
    combinationSetId: string;
}

export interface GetDataTypeCatalogForManualTaskRequest {
    targetSystemId: string;
}

export interface GetEnumerationEvaluationParameterForManualTaskRequest {
    enumerationId: string;
}

export interface GetMedicalSystemSetupTemplateRequest {
    getMedicalSystemSetupTemplate?: GetMedicalSystemSetupTemplate;
}

export interface GetMedicalSystemTypesScopesRequest {
    renameNone: boolean;
}

export interface GetMedicalSystemsForTaskRequest {
    getMedicalSystemsForTaskRequestDto?: GetMedicalSystemsForTaskRequestDto;
}

export interface GetNumericEvaluationParameterTemplateForManualTaskRequest {
    getNumericEvaluationParameterTemplateDto?: GetNumericEvaluationParameterTemplateDto;
}

export interface GetSetupCombinationsRequest {
    getCombinationTableDto?: GetCombinationTableDto;
}

export interface GetTaskItemRequest {
    id: string;
}

export interface GetTaskItemBeamShapingTemplateRequest {
    getBeamShapingGroupDto?: GetBeamShapingGroupDto;
}

export interface GetTaskItemEvaluationScopesForBccRequest {
    getTaskItemEvaluationScopeDto?: GetTaskItemEvaluationScopeDto;
}

export interface GetTaskItemListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetTaskItemQaEquipmentSetupTemplateRequest {
    getQaEquipmentSetupTemplateDto?: GetQaEquipmentSetupTemplateDto;
}

export interface GetTaskItemQaRtSystemTemplateRequest {
    getQaRtSystemTemplateDto?: GetQaRtSystemTemplateDto;
}

export interface GetTaskItemReferenceMeasurementResultsRequest {
    measurementId: string;
}

export interface TaskItemAcceptReferenceMeasurementRequest {
    acceptReferenceMeasurementDto?: AcceptReferenceMeasurementDto;
}

export interface UpdateTaskItemRequest {
    id: string;
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

export interface ValidateTaskItemRequest {
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

/**
 * 
 */
export class TaskItemsApi extends runtime.BaseAPI {

    /**
     */
    async copyTaskItemAreaRaw(requestParameters: CopyTaskItemAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemAreaDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/copy-task-item-area`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyTaskItemAreaDtoToJSON(requestParameters.copyTaskItemAreaDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemAreaDtoFromJSON(jsonValue));
    }

    /**
     */
    async copyTaskItemArea(requestParameters: CopyTaskItemAreaRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.copyTaskItemAreaRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemAreaDto>(response, errorHandlers);
    }

    /**
     * Adds a new entity
     */
    async createTaskItemRaw(requestParameters: CreateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters.createOrUpdateTaskItemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createTaskItem(requestParameters: CreateTaskItemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createTaskItemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteTaskItemRaw(requestParameters: DeleteTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteTaskItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteTaskItem(requestParameters: DeleteTaskItemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteTaskItemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getCachedSetupCombinationsRaw(requestParameters: GetCachedSetupCombinationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParameterCombinationTableDto>> {
        if (requestParameters.combinationSetId === null || requestParameters.combinationSetId === undefined) {
            throw new runtime.RequiredError('combinationSetId','Required parameter requestParameters.combinationSetId was null or undefined when calling getCachedSetupCombinations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/setup-combinations/{combinationSetId}`.replace(`{${"combinationSetId"}}`, encodeURIComponent(String(requestParameters.combinationSetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ParameterCombinationTableDtoFromJSON(jsonValue));
    }

    /**
     */
    async getCachedSetupCombinations(requestParameters: GetCachedSetupCombinationsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getCachedSetupCombinationsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ParameterCombinationTableDto>(response, errorHandlers);
    }

    /**
     */
    async getDataTypeCatalogForManualTaskRaw(requestParameters: GetDataTypeCatalogForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DataTypeInfoDto>>> {
        if (requestParameters.targetSystemId === null || requestParameters.targetSystemId === undefined) {
            throw new runtime.RequiredError('targetSystemId','Required parameter requestParameters.targetSystemId was null or undefined when calling getDataTypeCatalogForManualTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/datatype-catalog/{targetSystemId}`.replace(`{${"targetSystemId"}}`, encodeURIComponent(String(requestParameters.targetSystemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataTypeInfoDtoFromJSON));
    }

    /**
     */
    async getDataTypeCatalogForManualTask(requestParameters: GetDataTypeCatalogForManualTaskRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataTypeCatalogForManualTaskRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<DataTypeInfoDto>>(response, errorHandlers);
    }

    /**
     */
    async getEnumerationEvaluationParameterForManualTaskRaw(requestParameters: GetEnumerationEvaluationParameterForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnumerationEvaluationParameterDto>> {
        if (requestParameters.enumerationId === null || requestParameters.enumerationId === undefined) {
            throw new runtime.RequiredError('enumerationId','Required parameter requestParameters.enumerationId was null or undefined when calling getEnumerationEvaluationParameterForManualTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/enumeration-evaluation-parameter/{enumerationId}`.replace(`{${"enumerationId"}}`, encodeURIComponent(String(requestParameters.enumerationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationEvaluationParameterDtoFromJSON(jsonValue));
    }

    /**
     */
    async getEnumerationEvaluationParameterForManualTask(requestParameters: GetEnumerationEvaluationParameterForManualTaskRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getEnumerationEvaluationParameterForManualTaskRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EnumerationEvaluationParameterDto>(response, errorHandlers);
    }

    /**
     */
    async getMedicalSystemSetupTemplateRaw(requestParameters: GetMedicalSystemSetupTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicalSystemSetupBaseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/template-medical-system-setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMedicalSystemSetupTemplateToJSON(requestParameters.getMedicalSystemSetupTemplate),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemSetupBaseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getMedicalSystemSetupTemplate(requestParameters: GetMedicalSystemSetupTemplateRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemSetupTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<MedicalSystemSetupBaseDto>(response, errorHandlers);
    }

    /**
     */
    async getMedicalSystemTypesScopesRaw(requestParameters: GetMedicalSystemTypesScopesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TypesScopeDto>> {
        if (requestParameters.renameNone === null || requestParameters.renameNone === undefined) {
            throw new runtime.RequiredError('renameNone','Required parameter requestParameters.renameNone was null or undefined when calling getMedicalSystemTypesScopes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/medical-system-scopes/{renameNone}`.replace(`{${"renameNone"}}`, encodeURIComponent(String(requestParameters.renameNone))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue));
    }

    /**
     */
    async getMedicalSystemTypesScopes(requestParameters: GetMedicalSystemTypesScopesRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemTypesScopesRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TypesScopeDto>(response, errorHandlers);
    }

    /**
     */
    async getMedicalSystemsForTaskRaw(requestParameters: GetMedicalSystemsForTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalSystemRtSystemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/medical-systems-for-task`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMedicalSystemsForTaskRequestDtoToJSON(requestParameters.getMedicalSystemsForTaskRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalSystemRtSystemDtoFromJSON));
    }

    /**
     */
    async getMedicalSystemsForTask(requestParameters: GetMedicalSystemsForTaskRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMedicalSystemsForTaskRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<MedicalSystemRtSystemDto>>(response, errorHandlers);
    }

    /**
     */
    async getNumericEvaluationParameterTemplateForManualTaskRaw(requestParameters: GetNumericEvaluationParameterTemplateForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NumericEvaluationParameterTemplateDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/numeric-evaluation-parameter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetNumericEvaluationParameterTemplateDtoToJSON(requestParameters.getNumericEvaluationParameterTemplateDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => NumericEvaluationParameterTemplateDtoFromJSON(jsonValue));
    }

    /**
     */
    async getNumericEvaluationParameterTemplateForManualTask(requestParameters: GetNumericEvaluationParameterTemplateForManualTaskRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getNumericEvaluationParameterTemplateForManualTaskRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<NumericEvaluationParameterTemplateDto>(response, errorHandlers);
    }

    /**
     */
    async getQaEquipmentTypesScopeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TypesScopeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/qa-equipment-scope`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue));
    }

    /**
     */
    async getQaEquipmentTypesScope(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentTypesScopeRaw(initOverrides);
        return this.configuration.handleFunction<TypesScopeDto>(response, errorHandlers);
    }

    /**
     */
    async getSetupCombinationsRaw(requestParameters: GetSetupCombinationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParameterCombinationTableDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/setup-combinations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCombinationTableDtoToJSON(requestParameters.getCombinationTableDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ParameterCombinationTableDtoFromJSON(jsonValue));
    }

    /**
     */
    async getSetupCombinations(requestParameters: GetSetupCombinationsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getSetupCombinationsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ParameterCombinationTableDto>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getTaskItemRaw(requestParameters: GetTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTaskItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getTaskItem(requestParameters: GetTaskItemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskItemBeamShapingTemplateRaw(requestParameters: GetTaskItemBeamShapingTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BeamShapingGroupDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/beam-shaping-template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBeamShapingGroupDtoToJSON(requestParameters.getBeamShapingGroupDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => BeamShapingGroupDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTaskItemBeamShapingTemplate(requestParameters: GetTaskItemBeamShapingTemplateRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemBeamShapingTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<BeamShapingGroupDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskItemEvaluationScopesForBccRaw(requestParameters: GetTaskItemEvaluationScopesForBccRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EvaluationParameterScopeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/evaluation-scopes-bcc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTaskItemEvaluationScopeDtoToJSON(requestParameters.getTaskItemEvaluationScopeDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EvaluationParameterScopeDtoFromJSON));
    }

    /**
     */
    async getTaskItemEvaluationScopesForBcc(requestParameters: GetTaskItemEvaluationScopesForBccRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemEvaluationScopesForBccRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<EvaluationParameterScopeDto>>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getTaskItemListRaw(requestParameters: GetTaskItemListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfTaskItemDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTaskItemDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getTaskItemList(requestParameters: GetTaskItemListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfTaskItemDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskItemQaEquipmentSetupTemplateRaw(requestParameters: GetTaskItemQaEquipmentSetupTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemQaEquipmentSetupDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/template-qa-equipment-setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetQaEquipmentSetupTemplateDtoToJSON(requestParameters.getQaEquipmentSetupTemplateDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemQaEquipmentSetupDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTaskItemQaEquipmentSetupTemplate(requestParameters: GetTaskItemQaEquipmentSetupTemplateRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemQaEquipmentSetupTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemQaEquipmentSetupDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskItemQaRtSystemTemplateRaw(requestParameters: GetTaskItemQaRtSystemTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QaRtSystemTemplateDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/template-qa-rt-systems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetQaRtSystemTemplateDtoToJSON(requestParameters.getQaRtSystemTemplateDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => QaRtSystemTemplateDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTaskItemQaRtSystemTemplate(requestParameters: GetTaskItemQaRtSystemTemplateRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemQaRtSystemTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<QaRtSystemTemplateDto>(response, errorHandlers);
    }

    /**
     */
    async getTaskItemReferenceMeasurementResultsRaw(requestParameters: GetTaskItemReferenceMeasurementResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemReferenceMeasurementResultsDto>> {
        if (requestParameters.measurementId === null || requestParameters.measurementId === undefined) {
            throw new runtime.RequiredError('measurementId','Required parameter requestParameters.measurementId was null or undefined when calling getTaskItemReferenceMeasurementResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/task-items/reference-measurement-results/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters.measurementId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemReferenceMeasurementResultsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTaskItemReferenceMeasurementResults(requestParameters: GetTaskItemReferenceMeasurementResultsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTaskItemReferenceMeasurementResultsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemReferenceMeasurementResultsDto>(response, errorHandlers);
    }

    /**
     */
    async taskItemAcceptReferenceMeasurementRaw(requestParameters: TaskItemAcceptReferenceMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/accept-reference-measurement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptReferenceMeasurementDtoToJSON(requestParameters.acceptReferenceMeasurementDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async taskItemAcceptReferenceMeasurement(requestParameters: TaskItemAcceptReferenceMeasurementRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.taskItemAcceptReferenceMeasurementRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateTaskItemRaw(requestParameters: UpdateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskItemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTaskItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters.createOrUpdateTaskItemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateTaskItem(requestParameters: UpdateTaskItemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateTaskItemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TaskItemDto>(response, errorHandlers);
    }

    /**
     */
    async validateTaskItemRaw(requestParameters: ValidateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/task-items/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters.createOrUpdateTaskItemDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateTaskItem(requestParameters: ValidateTaskItemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateTaskItemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
